import { Select as SelectPrimitive } from '@mui/material';
import { Close, NavigateDown } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
import classnames from 'classnames';

import { Button } from '../../Button/Button';
import { Loader } from '../../Loader';

import { Option } from './Option';
import styles from './Select.module.scss';
import { SelectProps } from './Select.types';

export const Select = <T extends string, TClearable extends boolean = false>({
  className,
  slotProps,
  children,
  placeholder,
  value,
  clearable,
  loading,
  onChange,
  size,
  ...props
}: SelectProps<T, TClearable>) => (
  <SelectPrimitive
    value={value ?? ''}
    slotProps={{
      ...slotProps,
      root: {
        ...slotProps?.root,
        // @ts-expect-error we want to set the data attribute
        'data-icon-size': 'medium',
        className: classnames(styles.container, className, styles[size], !value && styles.empty),
      },
    }}
    displayEmpty
    IconComponent={NavigateDown}
    onChange={event => onChange((event.target.value || undefined) as T)}
    MenuProps={{ slotProps: { paper: { className: styles.menu } } }}
    endAdornment={
      loading ? (
        <Loader variant="secondary" size="small" className={styles.loader} />
      ) : clearable && value ? (
        <Button
          variant="tertiary"
          size="small"
          className={styles.clearButton}
          // @ts-expect-error this is only possible if clearable is set to true
          onClick={() => onChange(undefined)}
          disabled={props.disabled}
        >
          <Close />
        </Button>
      ) : undefined
    }
    {...props}
  >
    {placeholder && (
      <Option disabled={!clearable} value="">
        {placeholder}
      </Option>
    )}
    {children}
  </SelectPrimitive>
);
